module.exports = __webpack_public_path__ + "img/icon-stocks.e11c3eff.svg";